import { getQuestionsNext } from './actionTypes';

const defaultState = {
  isInitialized: false,
  isLoading: false,
  isError: false,
  errorType: '',
  data: [],
};

export const FAQ = (state = defaultState, { type, payload }) => {
  switch (type) {
    case getQuestionsNext.INIT:
      return {
        ...state,
        isLoading: true,
      };

    case getQuestionsNext.SUCCESS:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isInitialized: true,
        errorType: '',
        isError: false,
      };

    case getQuestionsNext.ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errorType: payload.message,
      };

    default:
      return state;
  }
};
